import { useState, useEffect } from 'react';
import Header from '../../components/layout/Header';
import Body from '../../components/layout/Body';
import Table from '../../components/layout/Table';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useURLParams } from '../../contexts/ParamsContext';
import { useNotice } from '../../contexts/NoticeContext';

import {
    fetchTaxonomies,
    deleteTaxonomy,
} from '../../utils/api';

const TaxonomyList = () => {
    const { updateUrlParams } = useURLParams();
    const { showNotice } = useNotice();
    const [taxonomies, setTaxonomies] = useState([]);

    useEffect(() => {
        fetchTaxonomies()
            .then(setTaxonomies)
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while fetching taxonomies.', 'voxycure-framework'),
                    'error'
                );
            });
    }, []);

    const handleDeleteTaxonomy = (id) => {
        if (!confirm(__('Are you sure you want to delete this taxonomy?', 'voxycure-framework'))) return;

        deleteTaxonomy(id)
            .then(() => {
                setTaxonomies((prev) => prev.filter((t) => t.id !== id));
                showNotice(__('Taxonomy deleted successfully.', 'voxycure-framework'), 'success');
            })
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while deleting taxonomy.', 'voxycure-framework'),
                    'error'
                );
            });
    };

    return (
        <>
            <Header>
                <h2 className="voxycure-editor__header-title">
                    {__('All Taxonomies', 'voxycure-framework')}
                </h2>
                <Button
                    className="components-button is-primary voxycure-button"
                    onClick={() => updateUrlParams({ view: 'new-taxonomy' })}
                >
                    {__('Add New Taxonomy', 'voxycure-framework')}
                </Button>
            </Header>

            <Body>
                <Table
                    columns={[
                        { key: 'name', label: __('Taxonomy Name', 'voxycure-framework') },
                        { key: 'status', label: __('Status', 'voxycure-framework') },
                        { key: 'actions', label: __('Actions', 'voxycure-framework') },
                    ]}
                    data={taxonomies}
                    emptyMessage={__('No taxonomies found. Try creating a new one.', 'voxycure-framework')}
                    renderRow={(taxonomy) => (
                        <tr key={taxonomy.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '0.75rem' }}>{taxonomy.name}</td>
                            <td style={{ padding: '0.75rem' }}>{taxonomy.status}</td>
                            <td style={{ padding: '0.75rem' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        isSmall
                                        isSecondary
                                        onClick={() => updateUrlParams({ view: 'edit-taxonomy', id: taxonomy.id })}
                                    >
                                        {__('Edit', 'voxycure-framework')}
                                    </Button>
                                    <Button
                                        isSmall
                                        isDestructive
                                        onClick={() => handleDeleteTaxonomy(taxonomy.id)}
                                    >
                                        {__('Delete', 'voxycure-framework')}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    )}
                />
            </Body>
        </>
    );
};

export default TaxonomyList;
